import { IGetAdminsListDTO } from '@/models/users.model';
import { Roles } from '@/models/admins.model';
import { TGetAdminsQuery } from '../helpers/types';

class GetAdminsListDTO implements IGetAdminsListDTO {
  roles?: Roles[];
  name?: string;
  email?: string;
  page: number;
  limit?: number;
  full_name?: string;
  date_from?: string;
  date_to?: string;
  region?: string;

  constructor({ roles, name, email, page, size, full_name, date_from, date_to, region }: TGetAdminsQuery) {
    if (roles) {
      this.roles = [roles] as Roles[];
    }
    this.name = name;
    this.email = email;
    this.limit = size;
    this.page = page ?? 1;
    this.limit = 10;
    this.full_name = full_name;
    this.date_from = date_from;
    this.date_to = date_to;
    this.region = region;
  }
}

export default GetAdminsListDTO;
